import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import Modal from '../../../components/Modal'
import Button from '../../../components/Button'
import Loader from '../../../components/Loader'
import { Fonts, Metrics } from '../../../Themes'

const CustomLoader = styled(Loader)`
  height: 565px;
`

const TermsAndConditions = styled.div`
  ${Fonts.style.Text};
  text-align: justify;
`

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.large};
`

const CustomModal = styled(Modal)`
  .modalContainer {
    max-height: none !important;
  }
`

const Terms = props => {
  const { t, handleRegister, router, fetching } = props
  return (
    <CustomModal
      visible
      closeAction={() => router.push('/landing')}
      header={<div className={'header'}>{t('Terms and Conditions')}</div>}
      footer={
        <div className={'header'}>
          <CustomButton label={t('Agree')} onClick={handleRegister} />
        </div>
      }
      backAction={router.goBack}>
      <CustomLoader visible={fetching} />
      <TermsAndConditions>{t('Terms')}</TermsAndConditions>
    </CustomModal>
  )
}

Terms.propTypes = {
  handleRegister: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  router: PropTypes.object,
  t: PropTypes.func,
  fetching: PropTypes.bool
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  Terms
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/Terms.js